import { Button, Paper, styled } from '@mui/material';

export const StyledProfilePopoverBannerWrap = styled(Paper)({
	borderRadius: '20px',
	padding: '20px 32px',
	position: 'relative',
});

export const StyledProfilePopoverBannerCloseWrap = styled('div')({
	position: 'absolute',
	top: '9px',
	right: '17px',
});

export const StyledProfilePopoverBannerImage = styled('img')({
	borderRadius: '16px',
	height: '80px',
	width: '100%',
	maxWidth: '100%',
	boxShadow: '0px 0px 30px 0px #827D8326',
	objectFit: 'cover',
});

export const StyledProfilePopoverBannerButton = styled(Button)({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: '8px',
	background: '#FFFFFFB2',
});
